import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface VisualModelCatalogItem {
  id: string;
  name: string;
  provider: string;
  media_type: 'image' | 'video' | 'motion' | 'stock';
  credits_per_scene: number;
  tier: string;
  tagline: string;
  description: string;
  features: string[];
  preview_url?: string | null;
  preview_type: 'image' | 'video' | 'motion';
  max_duration?: number | null;
  supported_aspect_ratios: string[];
  duration_options: number[];
  styles: { id: string; name: string; preview_url: string | null }[];
}

export interface VisualModelCatalogGroup {
  id: string;
  name: string;
  tagline: string;
  description: string;
  media_label: string;
  badge_color: string;
  preview_url?: string | null;
  preview_type: 'image' | 'video' | 'motion';
  recommended: boolean;
  min_credits_per_scene: number;
  max_credits_per_scene: number;
  default_model_id: string;
  models: VisualModelCatalogItem[];
}

interface VisualModelCatalogResponse {
  groups: VisualModelCatalogGroup[];
}

export function useModelCatalog() {
  return useQuery<VisualModelCatalogResponse>({
    queryKey: ['visual-model-catalog'],
    queryFn: async () => {
      const response = await api.get('/models/catalog');
      return response.data;
    },
    staleTime: Infinity,
    retry: 2,
  });
}

export function findCatalogModel(
  groups: VisualModelCatalogGroup[] | undefined,
  modelId: string | undefined,
) {
  if (!groups || !modelId) return undefined;
  return groups.flatMap(group => group.models).find(model => model.id === modelId);
}
